(() => {
  if (window.PawmoreHomeReviews) return;
  window.PawmoreHomeReviews = true;

  const initialiseCarousel = (carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;

    const track = carousel.querySelector('[data-carousel-track]');
    const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    const dots = carousel.querySelector('[data-carousel-dots]');
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track || items.length === 0) return;
    carousel.dataset.carouselReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const configuredPageSize = Number.parseInt(carousel.dataset.carouselPageSize || '1', 10);
    let pageStarts = [];
    let frame;

    const itemPosition = (item) => item.offsetLeft - items[0].offsetLeft;
    const maximumScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const scrollToPosition = (position) => {
      track.scrollTo({
        left: Math.min(position, maximumScroll()),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    const nearestItemIndex = () => {
      const current = track.scrollLeft;
      return items.reduce((nearest, item, index) => {
        const nearestDistance = Math.abs(itemPosition(items[nearest]) - current);
        const itemDistance = Math.abs(itemPosition(item) - current);
        return itemDistance < nearestDistance ? index : nearest;
      }, 0);
    };

    const nearestPageIndex = () => {
      const current = track.scrollLeft;
      return pageStarts.reduce((nearest, position, index) => {
        return Math.abs(position - current) < Math.abs(pageStarts[nearest] - current) ? index : nearest;
      }, 0);
    };

    const updateDots = () => {
      if (!dots || pageStarts.length === 0) return;
      const activePage = nearestPageIndex();
      dots.querySelectorAll('button').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === activePage ? 'true' : 'false');
      });
    };

    const updateArrows = () => {
      const currentItem = nearestItemIndex();
      if (previous) previous.disabled = currentItem === 0;
      if (next) next.disabled = currentItem === items.length - 1 || track.scrollLeft >= maximumScroll() - 2;
    };

    const updateControls = () => {
      updateDots();
      updateArrows();
    };

    const buildDots = () => {
      if (!dots) return;

      const pageSize = Math.max(1, configuredPageSize);
      pageStarts = [];
      for (let index = 0; index < items.length; index += pageSize) {
        pageStarts.push(Math.min(itemPosition(items[index]), maximumScroll()));
      }

      dots.replaceChildren();
      pageStarts.forEach((position, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pawmore-home__dot';
        dot.setAttribute('aria-label', `Show review page ${index + 1} of ${pageStarts.length}`);
        dot.addEventListener('click', () => scrollToPosition(position));
        dots.appendChild(dot);
      });
      updateDots();
    };

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });

    previous?.addEventListener('click', () => {
      const target = Math.max(0, nearestItemIndex() - 1);
      scrollToPosition(itemPosition(items[target]));
    });

    next?.addEventListener('click', () => {
      const target = Math.min(items.length - 1, nearestItemIndex() + 1);
      scrollToPosition(itemPosition(items[target]));
    });

    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const target = Math.min(items.length - 1, Math.max(0, nearestItemIndex() + direction));
      scrollToPosition(itemPosition(items[target]));
    });

    const resizeObserver = new ResizeObserver(() => {
      buildDots();
      updateControls();
    });
    resizeObserver.observe(track);

    buildDots();
    updateControls();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-pawmore-carousel]').forEach(initialiseCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
